export const CONST = {
    ROWS_OVERSCAN: 3,
    COLS_OVERSCAN: 2,
    RESIZE_TIMEOUT: 150,
    SCROLL_END_TIMEOUT: 250
};
